import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { AddQuoteResult, Quote } from "@/api_client";
import { client } from "@/api_client/client.gen";
import { getOfferQueryKey } from "@/hooks/api/offer/offerQueryKey";

export const useAddProduct = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (product: Quote) => {
      const response = await client.post<AddQuoteResult>({
        url: `/api/${product?.productType}/`,
        body: product,
      });
      const result =
        (response as { data?: AddQuoteResult }).data ??
        (response as unknown as AddQuoteResult | undefined);
      if (!result) {
        throw new Error("Add product response missing data");
      }
      return result;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(getOfferQueryKey(), data.offer);
    },
  });
};
